import styled from 'styled-components';
import TextImplementation from './implementation/TextImplementation';
var TextComponent = styled(TextImplementation)(function (props) {
    var styleObject = props.theme.coreThemes.text.getStyleObjectBuilder(props, 'font', 'textAlign', 'margin', 'color')
        .withBaseStyle({
        lineHeight: 'normal'
    })
        .withOptionalStyle({
        flex: 1
    }, function (x) { return x.stretch; })
        .withOptionalStyle({
        userSelect: 'text',
        cursor: 'auto'
    }, function (x) { return x.selectable; })
        .withOptionalStyle({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }, function (x) { return x.overflowEllipsis; })
        .withCustomStyle(props.customStyle)
        .build();
    return styleObject;
});
export default TextComponent;
//# sourceMappingURL=TextComponent.js.map